import './EditDashboardModal.css';

import { Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppLoader from 'components/Loader';
import Modal from 'components/ModalWrapper';
import { TrackDashboardEdit } from 'utilities/insights';
import { resetUpdatingDashboard } from 'redux/actions/dashboard';
import swal from 'sweetalert2';
import { updateDashboard } from 'redux/thunks/dashboard';

const EditDashboardModal = (props) => {
    const { dashboard, onClose, show, siteId, dashboardId, isAdmin } = props;
    const [owner, setOwner] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const dashboardState = useSelector((state) => state.dashboard);

    useEffect(() => {
        if (dashboard) {
            setName(dashboard.name);
            setEmail(dashboard.owner.email);
            setOwner(dashboard.owner.name);
            setFieldErrors({});
        }
    }, [dashboard]);

    useEffect(() => {
        if (dashboardState.updatingDashboardSuccess) {
            swal.fire({
                type: 'success',
                title: 'Success',
                text: 'Dashboard updated successfully!',
                confirmButtonText: 'Ok',
            });
        }
    }, [dashboardState.updatingDashboardSuccess, dispatch]);

    const validate = () => {
        let errors = {};

        if (!name) {
            errors['name'] = '';
        }

        if (!email) {
            errors['email'] = '';
        }

        if (!owner) {
            errors['owner'] = '';
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }

        const data = {
            dashboardId: dashboardId,
            siteId: siteId,
            email: email,
            name: name,
            owner: owner,
        };
        TrackDashboardEdit(siteId, dashboardId);
        dispatch(updateDashboard(data));
    };

    useEffect(() => {
        if (dashboardState.updatingDashboardSuccess) {
            onClose();
            dispatch(resetUpdatingDashboard());
        }
    }, [dashboardState.updatingDashboardSuccess, onClose, dispatch]);

    return (
        <div>
            <Modal allowClickOutsideToClose height='small' open={show} onCloseClicked={onClose}>
                <Grid container direction='column' className='edit-dashboard-modal'>
                    <Grid container item justifyContent='center' className='edit-dashboard-modal__title'>
                        <Typography variant='h5'>Edit Dashboard</Typography>
                    </Grid>

                    <Grid container direction='column' className='edit-dashboard-modal__body'>
                        {dashboardState.updatingDashboard ? (
                            <AppLoader />
                        ) : (
                            <>
                                <TextField
                                    label='Dashboard Name *'
                                    placeholder='Enter dashboard name'
                                    error={'name' in fieldErrors}
                                    helperText={'name' in fieldErrors && 'This field is required'}
                                    variant='outlined'
                                    value={name}
                                    className='edit-dashboard-modal__form-field'
                                    onChange={(e) => setName(e.target.value)}
                                />
                                {isAdmin && (
                                    <TextField
                                        error={'owner' in fieldErrors}
                                        helperText={'owner' in fieldErrors && 'This field is required'}
                                        className='edit-dashboard-modal__form-field'
                                        variant='outlined'
                                        label='Owner *'
                                        placeholder='Enter owner'
                                        value={owner}
                                        onChange={(e) => setOwner(e.target.value)}
                                    />
                                )}
                                {isAdmin && (
                                    <TextField
                                        error={'email' in fieldErrors}
                                        helperText={'email' in fieldErrors && 'This field is required'}
                                        className='edit-dashboard-modal__form-field'
                                        variant='outlined'
                                        label='Email *'
                                        placeholder='Enter email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                )}
                            </>
                        )}
                    </Grid>

                    <Grid container justifyContent='space-between' className='edit-dashboard-modal__footer'>
                        <Button
                            color='default'
                            size='large'
                            variant='contained'
                            onClick={props.onClose}
                            className='edit-dashboard-modal__footer-button--close'
                        >
                            Close
                        </Button>
                        <Button
                            color='primary'
                            size='large'
                            variant='contained'
                            disabled={dashboardState.updatingDashboard}
                            onClick={handleSave}
                            className='edit-dashboard-modal__footer-button--save'
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

export default EditDashboardModal;
